var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _rect5, _rect6, _rect7, _rect8, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0F753C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9545 41.1818L80.3295 66.75H80.875L96.3182 41.1818H110.739L89.2273 76.0909L111.08 111H96.4205L80.875 85.6023H80.3295L64.7841 111H50.1932L72.25 76.0909L50.4659 41.1818H64.9545ZM120.668 111V41.1818H133.315V100.398H164.065V111H120.668ZM212.986 60.375C212.668 57.3977 211.327 55.0795 208.963 53.4205C206.622 51.7614 203.577 50.9318 199.827 50.9318C197.19 50.9318 194.929 51.3295 193.043 52.125C191.156 52.9205 189.713 54 188.713 55.3636C187.713 56.7273 187.202 58.2841 187.179 60.0341C187.179 61.4886 187.509 62.75 188.168 63.8182C188.849 64.8864 189.77 65.7955 190.929 66.5455C192.088 67.2727 193.372 67.8864 194.781 68.3864C196.19 68.8864 197.611 69.3068 199.043 69.6477L205.588 71.2841C208.224 71.8977 210.759 72.7273 213.19 73.7727C215.645 74.8182 217.838 76.1364 219.77 77.7273C221.724 79.3182 223.27 81.2386 224.406 83.4886C225.543 85.7386 226.111 88.375 226.111 91.3977C226.111 95.4886 225.065 99.0909 222.974 102.205C220.884 105.295 217.861 107.716 213.906 109.466C209.974 111.193 205.213 112.057 199.622 112.057C194.19 112.057 189.474 111.216 185.474 109.534C181.497 107.852 178.384 105.398 176.134 102.17C173.906 98.9432 172.702 95.0114 172.52 90.375H184.963C185.145 92.8068 185.895 94.8295 187.213 96.4432C188.531 98.0568 190.247 99.2614 192.361 100.057C194.497 100.852 196.884 101.25 199.52 101.25C202.27 101.25 204.679 100.841 206.747 100.023C208.838 99.1818 210.474 98.0227 211.656 96.5455C212.838 95.0455 213.44 93.2955 213.463 91.2955C213.44 89.4773 212.906 87.9773 211.861 86.7955C210.815 85.5909 209.349 84.5909 207.463 83.7955C205.599 82.9773 203.418 82.25 200.918 81.6136L192.974 79.5682C187.224 78.0909 182.679 75.8523 179.338 72.8523C176.02 69.8295 174.361 65.8182 174.361 60.8182C174.361 56.7045 175.474 53.1023 177.702 50.0114C179.952 46.9205 183.009 44.5227 186.872 42.8182C190.736 41.0909 195.111 40.2273 199.997 40.2273C204.952 40.2273 209.293 41.0909 213.02 42.8182C216.77 44.5227 219.713 46.8977 221.849 49.9432C223.986 52.9659 225.088 56.4432 225.156 60.375H212.986Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134 210C134 201.163 141.163 194 150 194H236.041V256.5H134V210Z",
    fill: "#21A366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.039 194H322.08C330.916 194 338.08 201.163 338.08 210V256.5H236.039V194Z",
    fill: "#33C481"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 256.5,
    width: 102.041,
    height: 62.5,
    fill: "#107C41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 236.039,
    y: 256.5,
    width: 102.041,
    height: 62.5,
    fill: "#21A366"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 319,
    width: 102.041,
    height: 62.5,
    fill: "#185C37"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 236.039,
    y: 319,
    width: 102.041,
    height: 62.5,
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134 381.5H236.041V444H150C141.163 444 134 436.837 134 428V381.5Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.039 381.5H338.08V428C338.08 436.837 330.916 444 322.08 444H236.039V381.5Z",
    fill: "#185C37"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_786",
    x: 38.1914,
    y: 40.2266,
    width: 191.918,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_786",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.28747315c52a0c63a7d1fff7e95b2236.svg";
export { ForwardRef as ReactComponent };